import React, { useState, useEffect } from "react";
import * as SC from "./PostEditorLinkedIn.styled.js";

import ChannelDataEditor from "../../Campaign__Create_ChannelDataEditor.jsx";
import ChannelDataSelectList from "../../Campaign__Create_ChannelDataSelectList.jsx";
import HTMLEditor from "../../Campaign__Create_HTMLEditor.jsx";
import {
  linkedInCareerLevels,
  linkedInEmploymentTypes,
  linkedInSectors,
  linkedInFunctions,
  linkedInLands
} from "../../constants";
import { channelsByShortName } from "../../../../../data/app__channels";
import { useTranslation } from "react-i18next";

const PostEditorLinkedIn = ({
  postData,
  channelData,
  updatePost,
  updateChannelData,
  editable,
  orgaLinkedInPageID,
  campaignLanguage
}) => {
  const [linkedInCompanyId, setLinkedInCompanyId] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (channelData.linkedInCompanyId) {
      setLinkedInCompanyId(channelData.linkedInCompanyId);
    } else if (orgaLinkedInPageID) {
      setLinkedInCompanyId(orgaLinkedInPageID);
    } else {
      setLinkedInCompanyId("");
    }
  }, [orgaLinkedInPageID, channelData]);

  const updateLinkedInCompanyId = (linkedIn) => {
    setLinkedInCompanyId(linkedIn.value);
  };

  useEffect(() => {
    updateChannelData({ key: "linkedInCompanyId", value: linkedInCompanyId });
  }, [linkedInCompanyId]);

  return (
    <SC.PostEditorLinkedInWrapper>
      <SC.HeaderPicture src="/images/linkedin-bg.jpeg" alt="" />
      <SC.HeaderWrapper>
        <SC.Logo src="/images/azubi.png" alt="" />
        <SC.HeaderIcons src="/images/linkedin_tools.png" alt="" />
        <SC.TitleWrapper>
          <ChannelDataEditor
            updateChannelData={updateChannelData}
            value={channelData.title}
            dataKey="title"
            textStyle={SC.titleStyle}
            limit={channelsByShortName.linkedin.limits.title}
            label={t("Job Title")}
            tooltip={t("Job Title")}
            editable={editable}
          />
        </SC.TitleWrapper>
        <SC.CompanyWrapper>
          <ChannelDataEditor
            updateChannelData={updateChannelData}
            value={channelData.companyName}
            dataKey="companyName"
            textStyle={SC.companyNameStyle}
            limit={channelsByShortName.linkedin.limits.companyName}
            label={t("Company name")}
            tooltip={t("Company name")}
            editable={editable}
          />
          ·
          <ChannelDataEditor
            updateChannelData={updateChannelData}
            value={channelData.pageName}
            dataKey="pageName"
            textStyle={SC.pageNameStyle}
            limit={channelsByShortName.linkedin.limits.pageName}
            label={t("Location")}
            tooltip={t("Location")}
            editable={editable}
          />
          ·
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 0 }}>
            <ChannelDataEditor
              updateChannelData={updateLinkedInCompanyId}
              value={linkedInCompanyId}
              dataKey="linkedInCompanyId"
              textStyle={SC.pageNameStyle}
              limit={channelsByShortName.linkedin.limits.companyId}
              label={t("Company ID")}
              tooltip={t("Company ID")}
              editable={editable}
            />
            {linkedInCompanyId ? (
              <a
                href={`https://www.linkedin.com/jobs/search/?${new URLSearchParams({
                  f_C: linkedInCompanyId
                })}`}
                rel="noreferrer noopener"
                target="_blank"
              >
                🌍
              </a>
            ) : null}
          </div>
        </SC.CompanyWrapper>
        <SC.HeaderInfo>
          <SC.HeaderInfoText>
            <div>
              <b style={{ color: "black" }}>{t("NEW", { lng: campaignLanguage })}</b>{" "}
              {t("Posted", { lng: campaignLanguage })}: 2{" "}
              {t("minutes ago", { lng: campaignLanguage })}
            </div>
          </SC.HeaderInfoText>
          <div style={{ display: "flex" }}>
            <SC.SaveButton>{t("Save", { lng: campaignLanguage })}</SC.SaveButton>
            <SC.ApplyButton target="_blank" href={channelData?.url || "#"}>
              {t("Easy Apply", { lng: campaignLanguage })}
            </SC.ApplyButton>
          </div>
        </SC.HeaderInfo>
        <SC.Underline />
      </SC.HeaderWrapper>
      <SC.BodyWrapper>
        <SC.BodyContent>
          {editable && (
            <SC.Requirements>
              <SC.SelectListsWrapper>
                {!editable && ( // this is not used anymore
                  <SC.SelectListWrapper>
                    <ChannelDataSelectList
                      label={t("Country")}
                      options={linkedInLands}
                      value={channelData.land}
                      dataKey="land"
                      updateChannelData={updateChannelData}
                    />
                  </SC.SelectListWrapper>
                )}
                <SC.SelectListWrapper>
                  <ChannelDataSelectList
                    label={t("Career Level")}
                    options={linkedInCareerLevels}
                    value={channelData.careerLevel}
                    dataKey="careerLevel"
                    updateChannelData={updateChannelData}
                    editable={editable}
                  />
                </SC.SelectListWrapper>
                <SC.SelectListWrapper>
                  <ChannelDataSelectList
                    label={t("Employment Type")}
                    options={linkedInEmploymentTypes}
                    value={channelData.employmentType}
                    dataKey="employmentType"
                    updateChannelData={updateChannelData}
                    editable={editable}
                  />
                </SC.SelectListWrapper>
              </SC.SelectListsWrapper>
              <SC.SelectListsWrapper>
                <SC.SelectListWrapper>
                  <ChannelDataSelectList
                    label={t("Industry")}
                    options={linkedInSectors}
                    value={channelData.sector}
                    dataKey="sector"
                    updateChannelData={updateChannelData}
                    editable={editable}
                  />
                </SC.SelectListWrapper>
                <SC.SelectListWrapper>
                  <ChannelDataSelectList
                    label={t("Function")}
                    options={linkedInFunctions}
                    value={channelData.function}
                    dataKey="function"
                    updateChannelData={updateChannelData}
                    editable={editable}
                  />
                </SC.SelectListWrapper>
              </SC.SelectListsWrapper>
              <SC.RequirementsDetails>
                {t("Job Ad Details", { lng: campaignLanguage })}
              </SC.RequirementsDetails>
            </SC.Requirements>
          )}
          <SC.HTMLEditorWrapper>
            <HTMLEditor
              html={postData.jobPostingMarkup}
              updatePost={updatePost}
              editable={editable}
            />
          </SC.HTMLEditorWrapper>
        </SC.BodyContent>
        <SC.Underline />
      </SC.BodyWrapper>
    </SC.PostEditorLinkedInWrapper>
  );
};

export default PostEditorLinkedIn;
